export default __webpack_public_path__ + "static/media/app-screens-v2-67-2_10.ba8f9fae.jpg";